// src/resources/sections/monitorConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const MONITOR_CONFIG: ResourceConfig[] = [
  {
    name: "monitors",
    label: "Monitors",
    schema: "monitor",
    fields: [
      {
        source: "target",
        label: "target",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "module",
        label: "module",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["target", "module"],
  },
  {
    name: "monitor_results",
    label: "Monitor Results",
    schema: "monitor",
    fields: [
      {
        source: "monitor_id",
        label: " monitor_id",
        kind: "number",
        list: true,
        form: true,
      },
      { source: "time", label: "time", kind: "date", list: true, form: true },
      {
        source: "module",
        label: "module",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "target",
        label: "target",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "success",
        label: "success",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "probe_duration_seconds",
        label: "probe_duration_seconds",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "resolve_ip",
        label: "resolve_ip",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "http_status_code",
        label: "http_status_code",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "tls_cert_expiry_days",
        label: "tls_cert_expiry_days",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "dns_lookup_seconds",
        label: "dns_lookup_seconds",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "tcp_connect_seconds",
        label: "tcp_connect_seconds",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "tls_handshake_seconds",
        label: "tls_handshake_seconds",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "http_duration_seconds",
        label: "http_duration_seconds",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "error_message",
        label: "error_message",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "labels",
        label: "labels",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["target", "time", "http_status_code", "error_message"],
  },
  {
    name: "settings",
    label: "Monitor Settings",
    schema: "monitor",
    fields: [
      {
        source: "blackbox_base",
        label: "blackbox_base",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "default_module",
        label: "default_module",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "default_period",
        label: "default_period",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "default_retention",
        label: "default_retention",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "http_timeout_ms",
        label: "http_timeout_ms",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "updated_at",
        label: "updated_at",
        kind: "date",
        list: true,
        form: true,
      },
    ],
    searchFields: ["blackbox_base"],
  },
];
